module.exports = __webpack_public_path__ + "img/ic-facebook.3d7755ce.svg";